export const attachmentsConstants = {
    FETCH_ATTACHMENTS: 'FETCH_ATTACHMENTS',
    FETCH_ATTACHMENT: 'FETCH_ATTACHMENT',
}

export const parentTypesDeletingURL = {
    docsComment: "docs/note_attachment/",
    documents: "/docs/deleteAttach?docId=",
    requests: "/Request/deleteAttach?requestid="
}